//VALORES FIJOS
export const TIEMPO_SESION                                   = 60 //Minutos
export const TIEMPO_RENOVAR_SESION                           = 1 //Minutos
export const CADENA_VACIA                                    = ''
export const DESC_TIPO_DOCUMENTO_DNI                         = 'DNI'
export const COD_NACIONALIDAD_PERUANA                        = 1
export const COD_TIPO_DOCUMENTO_RUC                          = 2

export const CANTIDAD_DIGITOS_TIPO_DOCUMENTO_1               = 8
export const CANTIDAD_DIGITOS_TIPO_DOCUMENTO_2               = 11
export const CANTIDAD_DIGITOS_TIPO_DOCUMENTO_3               = 12
export const CANTIDAD_DIGITOS_TIPO_DOCUMENTO_4               = 8

export const TIPO_COTIZACIONES_PRIORIZADAS                   = 1
export const TIPO_COTIZACIONES_NO_PRIORIZADAS                = 2
export const TIPO_COTIZACIONES_VENCIDAS                      = 3
export const TIPO_COTIZACIONES_VENDIDAS                      = 4

export const COD_ESTADO_SOLICITUD_EN_PROCESO_REGISTRO        = 1
export const COD_ESTADO_SOLICITUD_FIRMADA_SIN_PAGO           = 2
export const COD_ESTADO_SOLICITUD_FINALIZADA                 = 3
export const COD_ESTADO_SOLICITUD_FINALIZADA_PAGO_POSTERIOR  = 4
export const COD_ESTADO_SOLICITUD_FINALIZADA_SIN_PAGO        = 5
export const COD_ESTADO_SOLICITUD_PAGO_INCOMPLETO            = 6
export const COD_ESTADO_SOLICITUD_FINALIZADA_PAGO_INCOMPLETO = 7
export const COD_ESTADO_SOLICITUD_PAGO_SIN_FIRMA             = 8
export const COD_ESTADO_SOLICITUD_PAGO_INCOMPLETO_SIN_FIRMA  = 9
export const COD_ESTADO_SOLICITUD_FINALIZADA_FIRMA_POSTERIOR = 10
export const COD_ESTADO_SOLICITUD_FINALIZADA_SIN_FIRMA       = 11
export const COD_ESTADO_SOLICITUD_FIRMA_PENDIENTE            = 12

// CODIGO DE TIPOS DE PRODUCTOS
export const COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO           = 2
export const COD_TIPO_PRODUCTO_VIDA_TEMPORAL                 = 3
export const COD_TIPO_PRODUCTO_ACCIDENTES_PERSONALES         = 4
export const COD_TIPO_PRODUCTO_VIDA_INVERSION                = 5
export const COD_TIPO_PRODUCTO_VIDA_DEVOLUCION               = 6
export const COD_TIPO_PRODUCTO_GENERAL                       = 999

// CODIGOS DE PRODUCTOS ESPECIALES
export const COD_PRODUCTO_VIDA_INVERSION_CAPITAL             = "176";
export const COD_PRODUCTO_ESPECIAL_177                       = "177";
export const COD_PRODUCTO_ESPECIAL_178                       = "178";
export const SPECIAL_PRODUCT_CODES                           = [176, 177, 178, '176', '177', '178'];
export const COD_PREGUNTA_ORIGIN_FONDOS = 116;

// VALORES PARA REEMPLAZO/TRASPASO
export const TRANSFER_TYPE_TRASPASO                          = 2;
export const TRANSFER_OPTION_1                               = 1;
export const TRANSFER_OPTION_2                               = 2;

export const COD_TIPO_BENEFICIARIO_CONTINGENTE               = 1
export const COD_TIPO_BENEFICIARIO_PRINCIPAL                 = 2
export const COD_TIPO_BENEFICIARIO_UNICO                     = 3
export const COD_TIPO_BENEFICIARIO_APODERADO                 = 4

export const TIPO_CASO_1                                     = 1
export const TIPO_CASO_2                                     = 2
export const TIPO_CASO_3                                     = 3

export const COD_MONEDA_DOLARES                              = 1
export const COD_MONEDA_SOLES                                = 2
export const SIMBOLO_MONEDA_1                                = '$ '
export const SIMBOLO_MONEDA_2                                = 'S/ '
export const TIPO_CAMBIO_DEFAULT                             = 3.859

//REGLAS DE VALIDACION
export const TIPO_DATO_TEXTO                                 = 1;
export const TIPO_DATO_TEXTO_NUMERICO                        = 2;
export const TIPO_DATO_TEXTO_EMAIL                           = 3;
export const TIPO_DATO_NUMERICO                              = 4;
export const TIPO_DATO_DECIMAL                               = 5;
export const TIPO_DATO_FECHA                                 = 6;
export const TIPO_DATO_COMBO                                 = 7;
export const TIPO_DATO_ALPHA_NUMERICO                        = 8;
export const TIPO_DATO_BOOLEANO                              = 9;
export const TIPO_DATO_COMBO_TEXTO                           = 10;
export const TIPO_DATO_OTRO                                  = 11;
export const TIPO_DATO_TEXTO_MAYUSCULA                       = 12;
export const TIPO_DATO_ALPHA_NUMERICO_MAYUSCULA              = 13;
export const TIPO_DATO_TEXTO_EMAIL_MAYUSCULA                 = 14;
export const TIPO_DATO_OTRO_MAYUSCULA                        = 15;

export const METODO_PAGO_PIN_MOBILE                          = 'MobilePin'
export const METODO_PAGO_PIN_EMAIL                           = 'EmailPin'
export const CODIGO_VALIDACION_FIRMA_EN_PROCESO              = 1
export const CODIGO_VALIDACION_FIRMA_SIN_PAGO                = 2
export const CODIGO_VALIDACION_FIRMA_FINALIZADA              = 3
export const ESTADO_FIRMA_CORREO_ERRADO                      = 6
export const CODIGO_TIPO_PERSONA_NATURAL                     = 1
export const CODIGO_TIPO_PERSONA_JURIDICO                    = 2

export const FORMATO_FECHA_1                                 = 'dd/mm/yyyy';
export const FORMATO_FECHA_2                                 = 'dd-mm-yyyy';
export const FORMATO_FECHA_3                                 = 'dd/mm/yyyy hh:mm';
export const FORMATO_FECHA_4                                 = 'dd/mm/yyyy hh:mm:ss';
export const FORMATO_FECHA_5                                 = 'yyyy.mm.dd.hh.mm';

//TABLAS MAESTRAS
export const COD_TABLA_MAESTRA_CARGO                         = 2;
export const COD_TABLA_MAESTRA_ACTIVIDAD                     = 3;
export const COD_TABLA_MAESTRA_GIRO_EMPRESA                  = 7;
export const COD_TABLA_MAESTRA_PROFESION                     = 8;
export const COD_TABLA_MAESTRA_OCUPACION                     = 9;
export const COD_TABLA_MAESTRA_VINCULO_ASEGURADO             = 10;
export const COD_TABLA_MAESTRA_TIPO_DOCUMENTO_IDENTIDAD      = 13;
export const COD_TABLA_MAESTRA_ESTADO_CIVIL                  = 14;
export const COD_TABLA_MAESTRA_PARENTESCO                    = 36;
export const COD_TABLA_MAESTRA_TIPO_COBRANZA_RECURRENTE      = 37;
export const COD_TABLA_MAESTRA_PAISES                        = 39;
export const COD_TABLA_MAESTRA_NACIONALIDAD                  = 40;
export const COD_TABLA_MAESTRA_FORMATO_IMAGEN_PERMITIDO      = 52;
export const COD_TABLA_MAESTRA_ESTADO_FIRMA_SOLICITUD        = 54;
export const COD_TABLA_MAESTRA_OPCIONES_TRASPASO             = 57;

//PARAMETROS
export const COD_PARAMETRO_EDAD_MAXIMA_FU                   = 227;

//MENSAJE VALIDACION DE CAMPOS
export const MENSAJE_VALIDACION_PROSPECTO                    = 'Debe buscar un prospecto'
export const MENSAJE_VALIDACION_NOMBRES                      = 'Ingrese Nombres válidos'
export const MENSAJE_VALIDACION_APE_PATERNO                  = 'Ingrese un Apellido Paterno válido'
export const MENSAJE_VALIDACION_APE_MATERNO                  = 'Ingrese un Apellido Materno válido'
export const MENSAJE_VALIDACION_TIP_DOCUMENTO                = 'Seleccione un Tipo de Doc.'
export const MENSAJE_VALIDACION_NUM_DOCUMENTO                = 'Ingrese un Nro. Doc. válido'
export const MENSAJE_VALIDACION_FEC_NACIMIENTO               = 'Ingrese una Fecha válida'
export const MENSAJE_VALIDACION_NACIONALIDAD =
  'Seleccione una Nacionalidad válida'
export const MENSAJE_VALIDACION_EST_CIVIL = 'Seleccione un Estado Civil válido'
export const MENSAJE_VALIDACION_VINCULO = 'Seleccione un Vínculo válido'
export const MENSAJE_VALIDACION_EMPLEADOR_EMPRESA =
  'Ingrese un Empleador o Empresa válida'
export const MENSAJE_VALIDACION_GIRO = 'Ingrese un Giro válido'
export const MENSAJE_VALIDACION_CARGO = 'Seleccione un Cargo válido'
export const MENSAJE_VALIDACION_OCUPACION = 'Ingrese una Ocupación válida'
export const MENSAJE_VALIDACION_TIPO_LABORES =
  'Seleccione un Tipo de Labores'
export const MENSAJE_VALIDACION_PROFESION = 'Ingrese una Profesión válida'
export const MENSAJE_VALIDACION_INGRESO_ANUAL =
  'Ingrese un Ingreso Anual válido'
export const MENSAJE_VALIDACION_RAZON_SOCIAL =
  'Ingrese una Razón Social válida'
export const MENSAJE_VALIDACION_RUC = 'Ingrese un Nro. de RUC'
export const MENSAJE_VALIDACION_SUSCRIPCION =
  'Completar el formulario de suscripción digital'
export const SIMBOLO_OBLIGATORIEDAD_INPUTS = '*'
export const MENSAJE_VALIDACION_CENTRO_MEDICO = 'Seleccione un Centro Médico válido'
export const MENSAJE_VALIDACION_FECHA = 'Ingrese una Fecha válida'
export const MENSAJE_VALIDACION_HORA = 'Ingrese una Hora válida'
export const MENSAJE_VALIDACION_DIRECCION = 'Campo Obligatorio'
export const MENSAJE_VALIDACION_DISTRITO = 'Ingrese un distrito válido'
export const MENSAJE_VALIDACION_EMAIL = 'Ingrese un correo electrónico válido'
export const MENSAJE_VALIDACION_EMAIL_REPETIDO = 'Ingrese un correo electrónico diferente al del asegurado'
export const MENSAJE_VALIDACION_NUM_CELULAR = 'Ingrese un Nro. de celular válido'
export const MENSAJE_VALIDACION_SEXO = 'Seleccione una opción'
export const MENSAJE_VALIDACION_DEPARTAMENTO = 'Seleccione un Departamento válido'
export const MENSAJE_VALIDACION_PROVINCIA = 'Seleccione una Provincia válida'
export const MENSAJE_VALIDACION_PARENTESCO = 'Seleccione un Parentesco'
export const MENSAJE_VALIDACION_PORCENTAJE = 'Ingrese un porcentaje válido'

export const MENSAJE_VALIDACION_ALTURA = 'Ingrese Altura válida'
export const MENSAJE_VALIDACION_PESO = 'Ingrese Peso válido'
export const MENSAJE_VALIDACION_ORIGEN_FONDOS = 'Seleccione origen de fondo'

export const MENSAJE_VALIDACION_BROKER = 'El código de broker no existe'
export const MENSAJE_BROKER_OBLIGATORIO = 'Debe ingresar un código broker'
export const MENSAJE_BROKER_ENCONTRADO = '¡Código broker encontrado!'

export const MENSAJE_VALIDACION_TIPO_CREDITO = 'Seleccione un tipo de crédito'
export const MENSAJE_VALIDACION_ENTIDAD_FINANCIERA = 'Ingrese una entidad financiera'

//MENSAJES ADICIONAL 1
export const MENSAJE_OBLIGATORIO = 'Seleccione una opción'
export const MENSAJE_COMPANIA = 'Ingrese una compañia'
export const MENSAJE_ANIO_EMISION = 'Ingrese año de emisión'
export const MENSAJE_TIPO_PLAN = 'Ingrese un tipo de plan'
export const MENSAJE_SUMA_ASEGURADA = 'Ingrese una suma asegurada'

//MENSAJES PAGO RECURRENTE
export const MENSAJE_CAMPO_OBLIGATORIO = 'Campo Obligatorio'
export const MENSAJE_MEDIO_PAGO = 'Seleccione un medio de pago'
export const MENSAJE_TIPO_TARJETA = 'Seleccione un tipo de tarjeta'
export const MENSAJE_TIPO_ENTIDAD = 'Seleccione una entidad bancaria'
export const MENSAJE_TIPO_CUENTA = 'Seleccione un tipo de cuenta'
export const MENSAJE_FECHA_VENCIDA = 'La tarjeta ingresada está vencida, ingrese otra tarjeta'
export const MENSAJE_TARJETA_VALIDA = 'Verifique los dígitos impresos en su tarjeta'
export const MENSAJE_CUENTA_VALIDO = 'Ingrese un número de cuenta válido'
export const MENSAJE_VENTA_REALIZADA = 'La venta ya ha sido procesada.'
export const MENSAJE_COTIZACION_VENCIDA = 'La cotización se encuentra vencida.'
export const MENSAJE_COTIZACION_ELIMINADA = 'La cotización fue eliminada.'

//MENSAJES ERROR
export const MENSAJE_ERROR_SERVICIO_401 = 'Su sesión ha expirado.<br/>Por favor, vuelva a iniciar sesión.'
export const MENSAJE_ERROR_SERVICIO_404 = 'El servicio no se encuentra disponible por el momento'
export const MENSAJE_ERROR_SERVICIO_406 = 'Response no aceptable'
export const MENSAJE_ERROR_SERVICIO_500 = 'El servidor no se encuentra disponible por el momento'
export const MENSAJE_ERROR_SERVICIO_GENERICO = 'El servicio ha devuelto un error, comuníquese con el administrador'

//MENSAJE FIJOS
export const MENSAJE_PREGUNTA_BENEFICIARIOS = 'El Propuesto Asegurado solicita la opción de cobrar directamente las cuotas del beneficio (sin importar la edad del beneficiario).'

// TABS RESUMEN ADN
export const TABS_RESUMEN_ADN = [
  { id: 1, descripcion: 'Cotización de productos' },
  { id: 2, descripcion: 'Coberturas' },
  { id: 3, descripcion: 'Proyecciones y gráficos' }
]

export const DESC_ESCENARIO_1 = 'Escenario Esperado'
export const DESC_ESCENARIO_2 = 'Escenario Pesimista'
export const DESC_ESCENARIO_3 = 'Escenario Optimista'

export const CODIGO_PRODUCTOS_PROYECCION = '90,91,92,93,94,95,96,97,98,186,187,188,175,176,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,306,307,308,311,312,313,318,319,320,321,322,323,324,325,327,328,329,330,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345,346,347,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305'

export const CANTIDAD_REGISTROS_PROYECCIONES = 8
export const URL_POLITICA_INVERSION = 'https://www.pacifico.com.pe/seguros/vida/conoce-los-fondos-de-inversion?from=GoogleBT'

//Terminos Proyecciones - Fondo Universitario
export const TERMINOS_CONDICIONES_2 = [
  { id: 1, descripcion: 'El periodo de capitalización puede ser diferente al mostrado en esta proyección y dependerá del inicio de vigencia de la póliza.' },
  { id: 2, descripcion: 'El Valor de Rescate se encuentra sujeto a un cargo por rescate durante los diez (10) primeros años de vigencia de la póliza, cuyo importe se indica en las Condiciones Particulares de la póliza. ' }
]

//Terminos Proyecciones - Accidentes Personales
export const TERMINOS_CONDICIONES_4 = [
  { id: 1, descripcion: 'Los importes mostrados ilustran lo que sucedería en caso se paguen las cuotas correspondientes y, por lo tanto , son susceptibles de cambiar si existen primas impagas a la fecha de resolución.' }
]

//Terminos Proyecciones - Vida Inversion
export const TERMINOS_CONDICIONES_5 = [
  { id: 1, descripcion: 'Los escenarios mostrados en este documento son proyecciones estimadas que han sido elaboradas considerando periodos de acumulación de diez (10) años sobre la data histórica de nuestros fondos desde el año 2005 y de indices de referencia con perfiles de riesgo similares a dichos fondos desde el año 2007. <b>El escenario pesimista No PRESENTA UNA RENTABILIDAD MINIMA GANTIZADA</b>. Las TIR se muestran netas de la comisión de administración, la cual se encuentra en un rango de 0.65% a 3.35% del fondo de la cuenta correspondiente. Las TIR se aplican sobre los saldos de las cuentas asociadas a la póliza, no se aplican sobre la prima pagada . <b>Las TIR estimadas de los Fondos Controlados, Balanceados o de Capitalizacion varían en el tiempo en función a la rentabilidad de los activos que respaldan los fondos de inversión, NO OFRECIENDOSE GARANTIA alguna de restabilidad ni de capital, por tanto, los rendimientos de las cuentas podrán ser positivos o negativos.</b>' },
  { id: 2, descripcion: 'Los cargos del seguro representan los costo de las coberturas, gastos fijos y variables.' },
  { id: 3, descripcion: 'El saldo de la cuenta individual está afecto a cargos correspondientes a la deducción mensual, gastos y ajustes señalados en la póliza.' },
  { id: 4, descripcion: 'El saldo de la cuenta de excedentes está libre de cargos, salvo de la deducción mensual en caso se incumpla con pagar la prima oportunamente.' },
  { id: 5, descripcion: 'El Valor de Rescate se encuentra sujeto a un cargo por rescate durante los diez (10) primeros años de vigencia de la póliza, cuyo importe se indica en las Condiciones Particulares de la póliza.' }
]

//Terminos Cotizaciones - General
export const TERMINOS_GENERAL = [
  { id: 1, descripcion: 'Actualmente las pólizas de seguro de vida se encuentran inafectadas del IGV cuando el comprobante de pago es emitido a nombre de una persona natural que reside en el Perú.' },
  { id: 2, descripcion: 'Valor estimado de rescate y/o finalización, si se considera que la póliza se cancela en el tiempo indicado. Se toma el valor del escenario esperado para el fondo elegido.' }
]

export const ACLARACIONES_1 = [
  { id: 1, descripcion: 'El monto de la prima comercial está sujeta a la evaluación de las condiciones de asegurabilidad.' },
  { id: 2, descripcion: 'Nuestras primas podrán ser establecidas y pactadas tanto en moneda nacional como en moneda extranjera de conformidad con lo dispuesto en los artículos 1234° y 1237° del Código Civil. De aceptar la Compañía la presente solicitud, las primas podrán pagarse en Dólares Americanos o Soles al tipo de cambio venta establecido por la entidad recaudadora en la fecha de pago. El tipo de cambio venta se publica diariamente en las ventanillas de las entidades recaudadoras. En caso de contratar un producto en moneda extranjera, la prima indicada en S/ se consigna sólo como referencia y en cumplimiento de la ley 29571 y considera un tipo de cambio equivalente a S/{tipoCambio}.' }
]

export const FONDOS = [
  // {id: 1, descripcion: '<b>Fondos Garantizados:</b> Sin riesgo. Brindan una Tasa Interna de Retorno (TIR) anual garantizada.'},
  { id: 1, descripcion: '<b>Fondos Controlados:</b> Bajo riesgo. Tienen por objetivo el crecimiento estable de la inversión del Contratante con baja volatilidad.' },
  { id: 2, descripcion: '<b>Fondos Balanceados:</b> Riesgo moderado. Tienen por objetivo el crecimiento moderado de la inversión del Contratante con volatilidad media.' },
  { id: 3, descripcion: '<b>Fondos de Capitalización:</b> Alto riesgo. Tienen por objetivo el alto crecimiento de la inversión del Contratante con elevada volatilidad.' }
]

export const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
]

export const MAX_TAMANIO_IMG = 2120000//3150000

export const CODIGO_ENTIDAD_DEFAULT = 0;
export const CODIGO_TIPO_CREDITO_DEFAULT = 0;

export const ALERT_MESSAGE = "¡Alerta!";
export const PRODUCT_ENDOSADO = 50;
export const DEFAULT_DATE = "1900-01-01T17:00:00.000";
export const COD_COBRANZA_DIRECTA = 4;
export const COD_ENTIDAD_PRIMERA_CUOTA = 1;
export const COD_DEFAULT_OPERADOR_TARJETA = 0;

export const loginRequestScope = [
  process.env.REACT_APP_MSAL_REFRESH_TOKEN || "",
  process.env.REACT_APP_PRODUCT_SCOPE || "",
];

export const LOCAL_STORAGE = "localStorage";
export const STORAGE_NAME_ACCESS_TOKEN = "access.token";